import store from '@/store';
import authModule from '@/store/modules/auth';
import { getModule } from 'vuex-module-decorators';
import { ToolDefinition } from '../types';

const getUserDomainsTool: ToolDefinition = {
  name: 'get_user_domains',
  description: 'Get user-accessible domains. Use selected domain unless told otherwise. Returns domains with names and IDs. Then search assets/incidents across domains and aggregate by domain. If asked a cross domain question, use this tool to get the list of domains first.',
  input_schema: {
    type: 'object',
    properties: {},
    required: [],
  },
};

/**
 * Execute the get_user_domains tool
 */
export async function executeGetUserDomains(): Promise<{ domains: Array<{ id: string; name: string, isSelectedDomain: boolean }> } | { error: string }> {
  try {
    const auth = getModule(authModule, store);
    const { user } = auth;

    if (!user || !user.aggregatedDomains) {
      return { error: 'User information not available' };
    }

    const domains = user.aggregatedDomains.map((domain) => ({
      id: domain.id,
      name: domain.name,
      isSelectedDomain: domain.name === auth.selectedDomain?.name,
    }));

    return { domains };
  } catch (error) {
    return { error: (error as Error).message };
  }
}

export default getUserDomainsTool;
